import { IState } from '../../store';

export function getIsFlatTourAvailable(state: IState): boolean {
  return Boolean(state.flatTourBooking.schedule);
}
